/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Subscription_CanceledInputs */

const en_my_payments_subscription_canceled = /** @type {(inputs: My_Payments_Subscription_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ended`)
};

const pl_my_payments_subscription_canceled = /** @type {(inputs: My_Payments_Subscription_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakończona`)
};

/**
* | output |
* | --- |
* | "Ended" |
*
* @param {My_Payments_Subscription_CanceledInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_subscription_canceled = /** @type {((inputs?: My_Payments_Subscription_CanceledInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Subscription_CanceledInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_subscription_canceled(inputs)
	return en_my_payments_subscription_canceled(inputs)
});